
import { useMutation } from "@apollo/client";
import { UPDATE_MULTIPLE_SUBSCRIPTION_PAYMENT_METHOD } from "./update-multiple-subscription-paymentMethod.mutation";
import { IUpdateMultipleSubscriptionPaymentMethod } from "./update-multiple-subscription-paymentMethod.interface";

export const useUpdateMultipleSubscriptionPaymentMethod = () => {
  const [updateMultipleSubscriptionPaymentMethod, { data, loading, error }] =
     useMutation<{updateMultipleSubscriptionPaymentMethod:
         IUpdateMultipleSubscriptionPaymentMethod}>(UPDATE_MULTIPLE_SUBSCRIPTION_PAYMENT_METHOD);

  const updateMultipleSubscription = (wellnessIds: string[], cardId: string) => {
    updateMultipleSubscriptionPaymentMethod({
      variables: {
        wellnessIds,
        cardId,
      },
    });
  };

  return {
    updateMultipleSubscription,
    data: data?.updateMultipleSubscriptionPaymentMethod,
    loading,
    error,
  };
};
